var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('mainLayout'),_c('div',{staticClass:"contentAdmin mainContent"},[_c('checkAcces',{attrs:{"pageAccess":"praticien"}}),_c('CasPraticien',{staticClass:"casPraticien",attrs:{"global":false}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }